import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "wechat-auth-container"
};
const _hoisted_2 = {
  key: 0,
  class: "auth-loading"
};
const _hoisted_3 = {
  class: "loading-text"
};
const _hoisted_4 = {
  key: 1,
  class: "auth-prompt"
};
const _hoisted_5 = {
  key: 2,
  class: "error-tip"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$setup.isProcessing ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_cache[1] || (_cache[1] = _createElementVNode("div", {
    class: "loading-spinner"
  }, null, -1)), _createElementVNode("p", _hoisted_3, _toDisplayString($setup.loadingText), 1)])) : (_openBlock(), _createElementBlock("div", _hoisted_4, [_cache[2] || (_cache[2] = _createElementVNode("div", {
    class: "auth-icon"
  }, [_createElementVNode("i", {
    class: "fas fa-weixin"
  })], -1)), _cache[3] || (_cache[3] = _createElementVNode("h3", null, "微信授权提示", -1)), _cache[4] || (_cache[4] = _createElementVNode("p", null, "需要微信授权才能继续操作", -1)), _createElementVNode("button", {
    class: "btn-auth",
    onClick: _cache[0] || (_cache[0] = (...args) => $setup.startWechatAuth && $setup.startWechatAuth(...args))
  }, "立即授权")])), $setup.error ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_cache[5] || (_cache[5] = _createElementVNode("i", {
    class: "fas fa-exclamation-circle"
  }, null, -1)), _createTextVNode(" " + _toDisplayString($setup.error), 1)])) : _createCommentVNode("", true)]);
}